import React, { useEffect } from 'react';
// external imports
import { InputLabel, Input, Button, AppBar, Toolbar, FormHelperText } from '@material-ui/core';
// internal imports
import { useSetState } from '~/app/Utility/customHooks';
// redux imports
import { useSelector, useDispatch } from 'react-redux';
import { actions as setupPageActions } from '~/app/redux/setupPages/duck';
import { formHasErrors } from '../databaseSetupHelper';

const UpsertOccupation = props => {
  const dispatch = useDispatch();

  const [state, setState] = useSetState({
    inputErrors: {},
    isSubmitDisabled: false,
  });

  const { isEditingRecord, currentEditRecord } = useSelector(state => ({
    isEditingRecord: state.setupPageState.isEditingRecord,
    currentEditRecord: state.setupPageState.currentEditRecord,
  }));

  useEffect(() => {
    setState({
      isSubmitDisabled: formHasErrors(currentEditRecord, handleSetErrors),
    });
  }, [currentEditRecord]);

  const handleSetErrors = errors => {
    setState({ inputErrors: errors }); // set any errors to the local state
  };

  const handleInputChange = e => {
    dispatch(setupPageActions.updateCurrentEditRecord(e));
  };

  const handleUpsert = () => {
    props.handleUserDBUpsert(currentEditRecord);
  };

  const validateFields = () => {
    if (currentEditRecord.occupation == null || currentEditRecord.occupation === '') {
      return false;
    }
    return true;
  };

  return (
    <div>
      <AppBar position="static">
        <Toolbar style={styles.toolbar}>{isEditingRecord ? 'Edit ' : 'Add '} Occupation</Toolbar>
      </AppBar>
      <div style={{ margin: ' 2em' }}>
        <div style={{ textAlign: 'left', marginTop: '1em' }}>
          <div style={styles.sectionHeading}>Occupation</div>
          <div style={{ float: 'left', marginLeft: '2em' }}>
            <InputLabel style={styles.labelStyles} required={false} shrink>
              Occupation Name
            </InputLabel>
            <Input
              id="txtOccupationUpsertOccupationn"
              name="occupation"
              value={currentEditRecord.occupation}
              onChange={handleInputChange}
              style={styles.inputStyle}
              error={
                !currentEditRecord.occupation ||
                currentEditRecord.occupation === '' ||
                state.inputErrors?.occupation !== undefined
              }
              inputProps={{
                maxLength: '25',
              }}
              disableUnderline
            />
            {state.inputErrors?.occupation && (
              <FormHelperText>{state.inputErrors.occupation}</FormHelperText>
            )}
          </div>
        </div>
        <br />
        <div style={{ textAlign: 'right', margin: '2em' }}>
          <Button
            id="btnCancelAddUpsertOccupation"
            color="primary"
            onClick={() => props.handleCloseUpsertModal()}
          >
            Cancel
          </Button>
          <Button
            id="btnUpsertOccupation"
            color="primary"
            style={styles.button}
            onClick={handleUpsert}
            disabled={!validateFields() || state.isSubmitDisabled}
          >
            {isEditingRecord ? 'Save' : 'Add'}
          </Button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  labelStyles: {
    color: '#354052',
    textAlign: 'left',
    fontFamily: 'Roboto',
  },
  button: {
    width: '9em',
    fontSize: '14px',
    borderRadius: '4px',
    marginLeft: '2em',
  },
  toolbar: {
    backgroundColor: '#444A59',
  },
  sectionHeading: {
    color: '#1A173B',
    fontFamily: 'Roboto',
    fontSize: '21px',
    marginBottom: '1em',
    marginLeft: '1em',
  },
  inputStyle: {
    width: '20vw',
    height: '3.5vh',
  },
};

export default UpsertOccupation;
